import { mediaModuleClient, mediaRoutes } from 'common/services';
import type { MediaDataObject } from 'models/service';

export const getVideoMedia = async ({ id }: { id: string }) =>
  mediaModuleClient.get<MediaDataObject>(mediaRoutes.detail.index(id));
